import { markForTranslation as _ } from '@/../../i18n/scripts/utils'

export function isURL (str) {
  var pattern = new RegExp('^(?:(?:https?|ftp):\\/\\/)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-z\u00a1-\uffff]{2,})))(?::\\d{2,5})?(?:\\/\\S*)?$')
  return pattern.test(str)
}

export function normaliseLangCode (langCode) {
    return langCode.split('').map(function (char, idx) {
        if (idx > 2) {
            return char.toUpperCase()
        } else if (char === '-') {
            return '_'
        } else {
            return char
        }
    }).join('')
}

export function deNormaliseLangCode (langCode) {
    return langCode.replace('_', '-').toLowerCase()
}

export function getUrlLangCode () {
    return window.location.pathname.split('/')[1]
}

export function sortByKey (array, key) {
    return array.sort(function (a, b) {
        const x = a[key]
        const y = b[key]
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
    })
}

export function findByKey (array, key, val) {
    return array.find(function (item) {
        return item[key] === val
    })
}

export function mapToJsShallow (mapObj) {
    return JSON.parse(JSON.stringify(mapObj))
}

export function capitalize (string) {
    if (string.length) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }
    return string
}

export function normaliseFirefoxTrackId (trackID) {
  // For some reason Firefox appends curly braces to the id. Strip these out for the normal ID
  // *NB* Watch out for this as a gotcha in future bugs
  if (trackID && trackID.replace) {
    return trackID.replace('{', '').replace('}', '')
  }
  return trackID
}

export function evaluate (measure, operator, threshold) {
    switch (operator) {
        case 'lt':
            return measure < threshold
        case 'gt':
            return measure > threshold
        case 'eq':
            return measure === threshold
    }
}

export function rgbaToArray (input) {
  const parsed = input.split('(')[1].split(')')[0].split(',').map(function (str) { return parseFloat(str, 10) })
  if (parsed.length !== 4) {
    const err = Error('"Shared.utils.rgbaToArray()" method requires a valid rgba value. You provided ' + JSON.stringify(input) + ' which returned ' + parsed)
    throw err
  }
  return parsed
}

export function arrayToRgba (input) {
  if (input.length !== 4) {
    const err = Error('"Shared.utils.arrayToRgba()" method requires an input array of 4 characters. You provided ' + JSON.stringify(input))
    throw err
  }
  return 'rgba(' + input.join(', ') + ')'
}

export function rgbaToHex (input) {
    const [r, g, b, a] = rgbaToArray(input)
    return ('#' + r.toString(16) + g.toString(16) + b.toString(16) + (a * 255).toString(16).substring(0, 7))
}

export function errorToObj (error) {
  if (error) {
    const obj = {
      'name': error.name,
      'message': error.message
    }
    return obj
  } else {
    return error
  }
}

export function removeEmptyVals (obj, removeZeros, removeEmptyStrings, removeEmptyArrays) {
  return Object.keys(obj)
    .filter(function (key) {
      if (removeZeros && obj[key] === 0) {
        return false
      }
      if (removeEmptyStrings && obj[key] === '') {
        return false
      }
      if (removeEmptyArrays && obj[key].constructor === Array && obj[key].length === 0) {
        return false
      }
      // Remove undef. and null.
      return obj[key] !== null && obj[key] !== undefined
    })
    .reduce(function (newObj, key) {
      var temp = {}

      if (obj[key].constructor === Object) {
        temp[key] = removeEmptyVals(obj[key])
        return Object.assign(newObj, temp) // Recurse
      }
      temp[key] = obj[key]
      return Object.assign(newObj, temp) // Copy value
    }, {})
}

export function promiseTimeout (promise, ms) {

  let timeout = new Promise((resolve, reject) => {
    let tId = setTimeout(() => {
      clearTimeout(tId)
      return reject(new Error('Promise Timed out in ' + ms + 'ms.'))
    }, ms)
  })

  // Returns a race between our timeout and the passed in promise
  return Promise.race([
    promise,
    timeout
  ])
}

export function roundToPlaces (num, places = 0) {
  const roundPlaces = Math.pow(10, places)
  return Math.round((num * roundPlaces)) / roundPlaces
}

export function diffJsonArray (bigArray, smallArray, prop) {
  return bigArray.filter((bigArrayItem) => {
    return !smallArray.find((smallArrayItem) => {
      if (prop) {
        return smallArrayItem[prop] === bigArrayItem[prop]
      } else {
        return JSON.stringify(bigArrayItem) === JSON.stringify(smallArrayItem)
      }
    })
  })
}

export function diffArray (bigArray, smallArray) {
  return bigArray.filter((bigArrayItem) => {
    return !smallArray.find((smallArrayItem) => {
      return smallArrayItem === bigArrayItem
    })
  })
}

export function uniqueJSON (jsonArray, props = []) {
  const tempObj = {}
  jsonArray.forEach((item) => {
    const key = props.map(prop => item[prop]).join('-')
    tempObj[key] = item
  })
  return Object.values(tempObj)
}

export function objectWithout (obj, keysToRemove) {
  const newObj = Object.assign({}, obj)
  keysToRemove.forEach((key) => {
    delete newObj[key]
  })
  return newObj
}

export function languageNameByCode (code) {
  const langList = {
    'ar': _('Afrikaans'),
    'da': _('Danish'),
    'de': _('German'),
    'en': _('English'),
    'es': _('Spanish'),
    'fr': _('French'),
    'fi': _('Finnish'),
    'it': _('Italian'),
    'ja': _('Japanese'),
    'nl': _('Dutch'),
    'pt': _('Portuguese'),
    'sv': _('Swedish'),
    'cy': _('Welsh'),
    'zh': _('Chinese'),
    'afr': _('Afrikaans'),
    'dan': _('Danish'),
    'deu': _('German'),
    'eng': _('English'),
    'spa': _('Spanish'),
    'fra': _('French'),
    'fin': _('Finnish'),
    'ita': _('Italian'),
    'jpn': _('Japanese'),
    'nld': _('Dutch'),
    'por': _('Portuguese'),
    'swe': _('Swedish'),
    'cym': _('Welsh')
  }
  return langList[code]
}

export function requestFullScreen () {
  const doc = window.document
  const docEl = doc.documentElement

  const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen
  requestFullScreen.call(docEl)
}

export function arrayLast (arr, fallback = null) {
  if (arr.length) {
    return arr[arr.length - 1]
  }
  return fallback
}

export function arrayFirst (arr, fallback = null) {
  if (arr.length) {
    return arr[0]
  }
  return fallback
}

export function groupBy (arr, key) {
  return arr.reduce((h, obj) => {
    h[obj[key]] = (h[obj[key]] || []).concat(obj)
    return h
  }, {})
}

export async function regularRetry (fn, wait) {

}

export async function retryFn (fn, wait, currCount, maxCount, successVal = null, retry = 'regular') {

  const res = await delayCall(fn, wait)

  if (successVal && (res === successVal)) {
    return res
  } else {
    currCount += 1
    if (retry === 'exponential') {
      wait = wait * 2
    }
    if (currCount === maxCount) {
      throw (new Error('Function did not succeed after ' + maxCount + ' attempts. Return value: ' + res))
    } else {
      return retryFn(fn, wait, currCount, maxCount, successVal, retry)
    }
  }
}

export function delayCall (callback, timeout) {
  return new Promise((resolve, reject) => {
    return setTimeout(() => {
      return resolve(callback())
    }, timeout)
  })
}

export function formatAjaxError (err) {
  return {
    'name': err.name,
    'message': err.message,
    'url': err.config && err.config.url
  }
}

export function shuffleArray (arr) {
  let currentIndex = arr.length
  let temporaryValue
  let randomIndex

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = arr[currentIndex]
    arr[currentIndex] = arr[randomIndex]
    arr[randomIndex] = temporaryValue
  }

  return arr
}

export function addArray (arr) {
  return arr.reduce((total, num) => {
    return total + num
  }, 0)
}

export function isYoutubeLink (link) {
  return !!(link.match(/(http:|https:)?(\/\/)?(www\.)?(youtube.com|youtu.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/))
}


export function htmlDecode (input) {
  var doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}

export function getHashFromString (input) {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) - hash) + input.charCodeAt(i)
    hash |= 0
  }
  return hash
}

export function dateTimeLocaleString (date = new Date()) {
  const dateAsNumbers = date.toLocaleDateString().split('/').join('')
  const timeAsNumbers = date.toLocaleTimeString().split(':').join('')
  return dateAsNumbers + timeAsNumbers
}

export function encodeToCombinedUTF8 (input) {
  return input
          .split('%C3%A1').join('a%CC%81') // á
          .split('%C3%A0').join('a%CC%80') // à
          .split('%C3%81').join('A%CC%81') // Á
          .split('%C3%80').join('A%CC%80') // À
          .split('%C3%A9').join('e%CC%81') // é
          .split('%C3%A8').join('e%CC%80') // è
          .split('%C3%89').join('E%CC%81') // É
          .split('%C3%88').join('E%CC%80') // È
          .split('%C3%AD').join('i%CC%81') // í
          .split('%C3%AC').join('i%CC%80') // ì
          .split('%C3%8D').join('I%CC%81') // Í
          .split('%C3%8C').join('I%CC%80') // Ì
          .split('%C3%B3').join('o%CC%81') // ó
          .split('%C3%B2').join('o%CC%80') // ò
          .split('%C3%93').join('O%CC%81') // Ó
          .split('%C3%92').join('O%CC%80') // Ò
          .split('%C3%BA').join('u%CC%81') // ú
          .split('%C3%B9').join('u%CC%80') // ù
          .split('%C3%9A').join('U%CC%81') // Ú
          .split('%C3%99').join('U%CC%80') // Ù
          .split('%C3%A3').join('a%CC%83') // ã
          .split('%C3%B1').join('n%CC%83') // ñ
          .split('%C3%BC').join('u%CC%88') // ü
          .split('%C3%9C').join('U%CC%88') // Ü
          .split('%C3%A7').join('c%CC%A7') // ç
          .split('%C3%87').join('C%CC%A7') // Ç
}
